import { Component } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { JeevesEditContactModalComponent } from 'gung-standard-jeeves';
import { CustomerContactService, CustomerService } from 'gung-standard';

@Component({
    selector: 'colmec-edit-contact-modal',
    templateUrl: './colmec-edit-contact-modal.component.html',
    styleUrls: ['./colmec-edit-contact-modal.component.scss'],
    standalone: false
})
export class ColmecEditContactModalComponent extends JeevesEditContactModalComponent {
  constructor(
    protected formBuilder: FormBuilder,
    protected customerContactService: CustomerContactService,
    protected customerService: CustomerService,
    public activeModal: NgbActiveModal
  ) {
    super(formBuilder, customerContactService, customerService, activeModal);
  }
  initForm() {
    this.contactForm = this.formBuilder.group({
      name: this.formBuilder.control(this.customerContact.name ? this.customerContact.name : ''),
      CS1: this.formBuilder.group({
        comkod: '1',
        comnr: this.formBuilder.control(this.customerContact.extra.CS1 ? this.customerContact.extra.CS1.comnr : '')
      }),
      CS4: this.formBuilder.group({
        comkod: '4',
        comnr: this.formBuilder.control(this.customerContact.extra.CS4 ? this.customerContact.extra.CS4.comnr : '')
      }),
      CS8: this.formBuilder.group({
        comkod: '8',
        comnr: this.formBuilder.control(this.customerContact.extra.CS8 ? this.customerContact.extra.CS8.comnr : '')
      }),
      kp: this.formBuilder.group({
        edit: this.formBuilder.control(this.customerContact.extra.kp?.edit ? this.customerContact.extra.kp.edit : '')
      })
    });
  }
}
